export default __webpack_public_path__ + "static/media/bars_icon.58c4bae2.svg";